module.exports = __webpack_public_path__ + "img/car_0006.f05b7f5d.jpg";